
import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';

export default {
  components: {
    Uploader: Uploader
  },

  props: {
    demand: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      fileList: [],
      uploader: {
        drag: true,
        withCredentials: true,
        data: { local: 1, allow_types: 'mp4,jpg,jpeg,bmp,gif,png,zip' },
        accept: reduceFileAccept(['mp4', 'jpg', 'bmp', 'gif', 'png', 'zip'])
      },
      maxSize: 50
    };
  },


  watch: {
    'demand.reference_url': function demandReference_url(url) {
      // 只有存在 url 才展示列表
      if (url) {
        this.fileList = [{ url: url, name: this.demand.reference_name }];
      } else {
        this.fileList = [];
      }
    }
  },

  methods: {
    onChange: function onChange(file, fileList) {
      // 限制只有一个文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;

      if (!isLtMaxSize) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLtMaxSize;
    },
    onError: function onError() {
      this.$message.error('文件上传出错！');
    },
    onSuccess: function onSuccess(res, file) {
      var path = _.get(res, 'data.file_path');
      var name = _.get(res, 'data.origin_name');

      if (res.code === 0 && path && name) {
        this.$emit('success', { path: path, name: name, file: file });
      } else {
        this.$message.error(res.msg || '上传失败，请重新尝试');
      }
    }
  }
};